<template>
  <div>
    <character-select
      :selected="state.selectedNpcKey"
      :characters="getNpcCharacters(emitter.caseConf)"
      :disabled="readonly"
      :errors="sourceCharacterErrors"
      placeholder="Select NPC"
      @input="updateNpc"
    />
    <change-answer-effect
      effect-type="NPC_ANSWER"
      placeholder="NPC item"
      :get-dialogue-items="getDialogueItems"
      :put-data="putDataWithNpcData"
      v-bind="$props"
    />
  </div>
</template>

<script>
import get from 'lodash/get';
import nodeMixins from './mixins/NodeMixins';
import { getNpcCharacters } from '~lib/common/utils/characters';
import { getDialogueItemsForCharacter } from '~lib/common/utils/dialogue';
import CharacterSelect from './CharacterSelect.vue';
import ChangeAnswerEffect from './ChangeAnswerEffect.vue';

export default {
  name: 'change-npc-answer-effect',
  components: {
    CharacterSelect,
    ChangeAnswerEffect,
  },
  mixins: [ nodeMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'type'],
  data() {
    return {
      state: {
        selectedNpcKey: null,
      },
    };
  },
  computed: {
    selectedNpc() {
      const npcs = this.emitter.caseConf.npcs || [];
      return npcs.find(npc => npc.key === this.state.selectedNpcKey);
    },
    sourceCharacterErrors() {
      return this.getErrorsById('missingSourceCharacter');
    }
  },
  created() {
    const data = this.getData(this.ikey);
    this.state.selectedNpcKey = get(data, 'npcKey');
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    updateNpc(key) {
      this.state.selectedNpcKey = key;
      // First time selecting an npc we don't want to emit null id and cause validation errors
      if (!this.getData(this.ikey)) {
        return;
      }
      this.putDataWithNpcData(this.ikey, {
        id: null,
      });
    },
    putDataWithNpcData(key, data) {
      this.putData(key, {
        ...data,
        type: 'NPC_ANSWER',
        npcKey: this.state.selectedNpcKey,
      });
      this.emitter.trigger('process', this.control);
    },
    getNpcCharacters,
    getDialogueItems() {
      return getDialogueItemsForCharacter(this.emitter.caseConf, this.state.selectedNpcKey, 'questions')
    }
  },
};
</script>

<style scoped>
</style>